function cartOnload() {

    /**
     *
     */
    $.post(url("/ingresso/carrinho/update"), function (cart) {
        ajaxCart(cart, "");
    }, "json");

    /**
     * ACTION BUTTONS
     */
    $("[data-action]").click(function (e) {
        e.preventDefault();
        var data = $(this).data();

        $.post(data.action, function (cart) {
            ajaxCart(cart, data);
        }, "json");
    });

    /**
     * AJAX CART
     * @param cart
     * @param data
     */
    function ajaxCart(cart, data) {
        var modal_size = "sm"
        var modal = "#modal_" + modal_size;
        var modal_title = $(".modal_title_" + modal_size);
        var modal_content = $(".modal_content_" + modal_size);
        var tickets_total = $(".tickets_total");
        var products_total = $(".products_total");
        var cart_total = $(".cart_total");
        var installment = $('.installment_total');
        var btn_continue = $(".btn_continue");
        var tickets_total_count = 0;
        var products_total_count = 0;

        //MESSAGE
        if (cart.message) {
            modal_title.html("");
            modal_content.html(cart.message);
            openModal(modal);
        }

        //ACTION REMOVE
        if (data.btn == "remove" && !cart.message) {
            if (data.type == "ticket") {
                if ($(".ticket_item_quantity_" + data.id).text() == 1) {
                    // remove item
                    $(".ticket_item_" + data.id).addClass("d-none").fadeOut();
                }
            }
            if (data.type == "product") {
                if ($(".product_item_quantity_" + data.id).text() == 1) {
                    // remove item
                    $(".product_item_" + data.id).addClass("d-none").fadeOut();
                }
            }
        }

        //TICKETS ITEMS
        if (cart.cart.tickets) {
            $.each(cart.cart.tickets, function (index, ticket) {
                tickets_total_count += ticket.total;
                $(".ticket_item_quantity_" + ticket.id).html(ticket.quantity);
            });

            if (tickets_total_count != 0) {
                tickets_total.html(formater.format(tickets_total_count));
            } else {
                $('.tickets').html(
                    '<div class="row">' +
                    '<div class="col-12">' +
                    '<b>Adicione ingressos para prosseguir.</b> <a href="' + url("/ingresso/ingressos") + '" class="btn btn-style btn-success mt-4 mt-md-0">Adicionar ingressos</a>' +
                    '</div>' +
                    '</div>'
                );
            }
        }

        //PRODUCTS ITEMS
        if ( cart.cart.products) {
            $.each(cart.cart.products, function (index, product) {
                products_total_count += product.total;
                $(".product_item_quantity_" + product.id).html(product.quantity);
            });

            if (products_total_count != 0) {
                products_total.html(formater.format(products_total_count));
            } else {
                $('.products').html(
                    '<div class="row">' +
                    '<div class="col-12">' +
                    'Nenhum. <a href="' + url("/ingresso/produtos") + '" class="btn btn-style-line btn-sm">Adicionar um produto</a>' +
                    '</div>' +
                    '</div>'
                );
            }
        }

        if (tickets_total_count == 0) {
            $('.products_session').addClass("d-none").fadeOut();
        }

        //CREDIT COUPON
        if (cart.cart.credit && tickets_total_count != 0) {
            $(".coupon_num").html(cart.cart.credit.coupon);
            $(".coupon_description").html("Crédito de Reagendameto");
            $(".credit").html("Crédito: -" + formater.format(cart.cart.credit.amount));
            $(".credit").removeClass("d-none").fadeIn();

            $(".coupon_form").addClass("d-none");
            $(".coupon_validated").removeClass("d-none");
        } else {
            $(".coupon_form").removeClass("d-none");
            $(".coupon_validated").addClass("d-none");
            $(".credit").addClass("d-none").fadeIn();
        }

        //DISCOUNT
        if (cart.cart.discount) {
            //coupon
            if (cart.cart.discount.origin == 'coupon') {
                $(".coupon_num").html(cart.cart.discount.coupon);
                $(".coupon_description").html("Desconto: " + cart.cart.discount.description);
                $(".discount").html("Desconto: -" + formater.format(cart.cart.discount.amount));
                $(".discount").removeClass("d-none").fadeIn();

                $(".coupon_form").addClass("d-none");
                $(".coupon_validated").removeClass("d-none");
            }
            //partners
            if (cart.cart.discount.origin == 'partners') {
                $(".discount").html("Desconto Parceiros Thermas (" + cart.cart.discount.percent + "%): -" + formater.format(cart.cart.discount.amount));
                $(".discount").removeClass("d-none").fadeIn();
            }
        } else {
            $(".discount").addClass("d-none").fadeIn();
        }

        //SUBTOTAL
        if (tickets_total_count != 0 && (cart.cart.discount || cart.cart.credit)) {
            $(".subtotal").html("Subtotal: " + formater.format(cart.cart.subtotal));
            $(".subtotal").removeClass("d-none").fadeIn();
        } else {
            $(".subtotal").addClass("d-none").fadeIn();
            if (!cart.cart.credit) {
                $(".coupon_form").removeClass("d-none");
                $(".coupon_validated").addClass("d-none");
            }
        }

        //TOTAL
        if (tickets_total_count != 0) {
            cart_total.html(formater.format(cart.cart.total));
            installment.html(formater.format(cart.cart.total / 6));
            btn_continue.removeClass("disabled");
        } else {
            $(".row_products").addClass("d-none");
            $(".row_final").addClass("d-none");
        }
    }


    /**
     * COUPON INSERT
     */
    $("#form_cart_coupon").submit(function (e) {
        e.preventDefault();
        var form = $(this);
        var modal_size = "sm"
        var modal = "#modal_" + modal_size;
        var modal_title = $(".modal_title_" + modal_size);
        var modal_content = $(".modal_content_" + modal_size);

        form.ajaxSubmit({
            url: form.attr("action"),
            type: "POST",
            dataType: "json",
            beforeSend: function () {
                loaderShow();
            },
            success: function (cart) {

                // MESSAGE
                if (cart.message) {
                    setTimeout(function () {
                        modal_title.html("");
                        modal_content.html(cart.message);
                        openModal(modal);
                    }, 400);
                }

                //SUCCESS
                if (cart.cart) {
                    ajaxCart(cart, "");
                }

            },
            complete: function () {
                setTimeout(function () {
                    loaderClose();
                }, 600);
            }
        });
    });

    /**
     * COUPON REMOVE
     */
    $("[data-couponremove]").click(function (e) {
        e.preventDefault();
        var data = $(this).data();
        var coupon = $('.coupon_num').html();

        loaderShow();

        $.post(data.couponremove, {coupon: coupon}, function (cart) {
            ajaxCart(cart, data);
        }, "json");

        setTimeout(function () {
            loaderClose();
        }, 400);
    });

}